/* eslint-disable complexity */

/* eslint-disable vymo-ui/restrict-import */

/* eslint-disable no-case-declarations */

/* eslint-disable jsx-a11y/media-has-caption */

/* eslint-disable no-useless-return */
import React from 'react';
// import { closePortal } from 'src/workspace/utils';
import { Keys, locale } from 'src/i18n';
import { getCurrentEntityId, getDetails } from 'src/models/details/selectors';
import { getState } from 'src/store';
import axios from 'src/workspace/axios';
import { getAllowedActions } from '../revyre/details/selectors';
import { getDomainConfigByType } from '../revyre/selectors';
import {
  setStatus,
  setWorkflowMetaData,
  toggleAgentAI,
  toggleRecording,
} from './slice';
import { Cta } from './types';
import { sendMessage as sendWorkflowMessage } from './workflow/thunk';
import styles from './index.module.scss';

export const performCtaAction = async (cta: Cta, dispatch, chatSessionId) => {
  let currentEntityId = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  let module_code = '';
  let data = {};
  let messageData = '';
  switch (cta.type) {
    case 'list':
      data = {
        code: 'view-details',
        text: locale(Keys.VIEW_LEAD),
        params: {
          activity: 'main',
          code: 'leads',
          start_state: module_code,
        },
      };
      module_code = cta.meta_data?.module_code;
      if (window.hostApp?.platform === 'web') {
        window.open(
          `${window.origin}/#/${module_code}/leads`,
          '_blank',
          'noopener,noreferrer',
        );
      }
      messageData = JSON.stringify(data);
      // @ts-ignore
      if (window.Android) {
        // @ts-ignore
        window.Android.handleMessage(messageData);
      }
      // @ts-ignore
      if (window?.ReactNativeWebView?.postMessage) {
        // @ts-ignore
        window?.ReactNativeWebView?.postMessage(messageData, '*');
      }
      break;
    case 'lead':
      const { lead_code: leadCode, module_code: moduleCode } = cta.meta_data;
      data = {
        code: 'view-details',
        text: locale(Keys.VIEW_LEAD),
        params: {
          activity: 'leads',
          code: leadCode,
          start_state: moduleCode,
        },
      };
      messageData = JSON.stringify(data);

      // @ts-ignore
      if (window.Android) {
        // @ts-ignore
        window.Android.handleMessage(messageData);
      }
      // @ts-ignore
      if (window?.ReactNativeWebView?.postMessage) {
        // @ts-ignore
        window?.ReactNativeWebView?.postMessage(messageData, '*');
      }

      if (window.hostApp?.platform === 'web') {
        window.open(
          `${window.origin}/#/${moduleCode}/leads/${leadCode}/details`,
          '_blank',
          'noopener,noreferrer',
        );
      }
      break;
    case 'record-screen':
      dispatch(toggleRecording());
      return;
    case 'agent-ai':
      dispatch(toggleAgentAI(cta.meta_data));
      return;
    case 'workflow-config':
      const selectedModule = cta?.meta_data?.module || '';
      const allowedActions: any = [];
      let entityDetails: any = {};

      currentEntityId = getCurrentEntityId(getState());
      if (currentEntityId) {
        allowedActions.push(
          ...(getAllowedActions(getState(), currentEntityId, 'workflow') || []),
        );
        entityDetails = getDetails(getState(), currentEntityId);
      }

      const workflowConfig = getDomainConfigByType(
        getState(),
        selectedModule !== 'activity' ? 'workflow' : 'activity',
        selectedModule,
      );

      if (workflowConfig) {
        const createInputs = workflowConfig?.createConfig?.inputs;
        const allowedActionsMap = allowedActions.reduce((map, action) => {
          map[action.allowedAction] = action;
          return map;
        }, {});

        const allowedActionsInputs = (workflowConfig?.events || [])
          .map((event) => {
            if (allowedActionsMap[event.allowedAction]) {
              return {
                inputs: event.config.inputs,
                action: event.allowedAction,
              };
            }
            return null;
          })
          .filter(Boolean);

        dispatch(
          setWorkflowMetaData({
            inputs: [
              { action: 'create', inputs: createInputs },
              ...allowedActionsInputs,
            ],
            voContext: entityDetails ?? null,
            allowedActions: allowedActions.length ? allowedActions : null,
            entityId: currentEntityId,
          }),
        );
        dispatch(sendWorkflowMessage({ text: 'Yes', chatSessionId }));
      }
      return;
    case 'workflow-action':
      const { module, payload, action } = cta.meta_data;
      currentEntityId = getCurrentEntityId(getState());

      dispatch(
        setStatus({ type: 'info', message: 'Submitting...', duration: 10000 }),
      );
      try {
        if (action === 'create') {
          await axios.post(`/vymo/v3/workflow/${module}`, payload);
        } else {
          await axios.patch(
            `/vymo/v3/workflow/${module}/${currentEntityId}/${action}`,
            payload,
          );
        }
        dispatch(
          setStatus({
            type: 'success',
            message: `Successfully created`,
          }),
        );
        // closePortal?.();
      } catch (e: any) {
        dispatch(
          setStatus({
            type: 'error',
            message: `Error while submitting: ${e.getMessage()}`,
            duration: 10000,
          }),
        );
      }

      return;
    default:
      return;
  }
};

export const getFileViewer = (
  fileData: { file: string; type: string } | undefined,
) => {
  if (!fileData) return null;
  const { file, type } = fileData;
  switch (type) {
    case 'video/webm':
      return (
        <video
          src={file}
          controls
          className={styles.copilotv2__body__message__video}
        />
      );
    default:
      return null;
  }
};

export const getCallButtonLabel = (status) => {
  switch (status) {
    case 'connected':
      return 'Call Connected';
    case 'initial':
      return 'Start Call';
    case 'failed':
      return 'Failed, Try again';
    default:
      return 'Start Call';
  }
};

export const transformMessageCtas = (message: any) => {
  const linkCtas = (message?.leads_data || [])?.map((lead) => ({
    type: 'lead',
    title: lead.lead_name,
    meta_data: { ...lead },
  }));

  if (message?.total_count) {
    linkCtas.push({
      type: 'list',
      title: `${message?.total_count} leads found`,
      meta_data: {
        module_code: message?.leads_data?.[0]?.module_code || 'leads',
      },
    });
  }

  return [...(message?.ctas || []), ...linkCtas];
};
